import { connect } from 'react-redux'
import { withMe } from 'pobble-components/dist/pobble-user'
import School from './school'

const mapStateToProps = (state, { me, meRequest }) => ({
  canSeeSchoolTab: !meRequest.pending && me && me.account.policy.view_school_tab
})

export default withMe(
  connect(
    mapStateToProps,
    null
  )(School)
)
